jQuery(function($){
	$('.co-tile-wrapper').on('click', '.co-tile.attendance .actions', function(){
		let parentWrapper = $(this).closest('.co-tile-wrapper');
		let memberTile = $(this).closest('.co-tile');
		let partColumn = $(this).closest('.part');
		let part = memberTile.attr('part');
		let status = memberTile.attr('status');

		let memberId = memberTile.attr('member_id');
		let eventId = memberTile.attr('event_id');

		const typeaheadResult = memberTile.attr('typeahead_result');

		if(parentWrapper.hasClass('uncounted-members')) {
			$('.present-members .part[part=' + part + ']').each(function(){
				addToColumn($(this), memberTile);
			});

			updateTypeaheadResults(memberId, typeaheadResult, true);

			let data = {
				action: 'choralorg_attendance_update_record',
				member_id: memberId,
				event_id: eventId
			};

			$.post('/wp-admin/admin-ajax.php', data, function(response){
				console.log(response);
			});
		} else {
			$('.uncounted-members .part[part=' + part + ']').each(function(){
				$(this).find('.status[status=' + status + ']').each(function(){
					addToColumn($(this), memberTile);
				});
			});

			updateTypeaheadResults(memberId, typeaheadResult);

			let data = {
				action: 'choralorg_attendance_update_record',
				member_id: memberId,
				event_id: eventId,
				remove: true
			};

			$.post('/wp-admin/admin-ajax.php', data, function(response){
				console.log(response);
			});
		}

		updateAttendanceTotals();
	});

	// setTimeout(function(){
	// 	updateAttendanceReportHeight();
	// }, 50);
	// $(window).resize(function(){
	// 	updateAttendanceReportHeight();
	// });

	function addToColumn(column, memberTile) {
		column.append(memberTile.prop('outerHTML'));
		memberTile.remove();
		sortToColumn(column);

		console.log(column);
		console.log(memberTile);
	}

	function updateTypeaheadResults(memberId, typeaheadResult, remove = false) {
		const fieldDiv = $('.field.typeahead[full_field_name="attendance_records_filter"]');
		const resultsDiv = fieldDiv.find('.results');
		const typeaheadInput = fieldDiv.find('input.typeahead-input');
		const resultsDivId = $('#' + resultsDiv.attr('result_div_id'));
		let resultsArray = JSON.parse(atob(resultsDivId.html()));
		let typeaheadResultObj = JSON.parse(atob(typeaheadResult));

		typeaheadInput.val('');

		if(remove) {
			$.each(resultsArray, function(index, result){
				console.log(result);
				let removeResult = false;
				if(result === undefined) {
					removeResult = true;
				} else if(result.hasOwnProperty('post_id') && result.post_id == memberId) {
					removeResult = true;
				}

				if(removeResult) resultsArray.splice(index, 1);
			});
		} else {
			resultsArray.push(typeaheadResultObj);
		}

		//Sort by name
		resultsArray.sort(sortByName);

		//Return to results div
		resultsDiv.attr('results', btoa(JSON.stringify(resultsArray)));
	}

	function sortToColumn(column) {
		columnItems = [];
		column.find('.co-tile').each(function(){
			columnItems.push({
				first_name: $(this).attr('first_name'),
				last_name: $(this).attr('last_name'),
				el: $(this)
			});
			$(this).remove();
		});

		columnItems.sort(sortByName);
		$.each(columnItems, function(index, value){
			column.append(value.el);
		});
	}

	function sortByName(a, b) {
		let keys = [
			'last_name',
			'first_name'
		];

		let returnValue = 0;
		$.each(keys, function(index, value){
			returnValue = compareValues(a, b, value);
			if(returnValue != 0) return false;
		});
		return returnValue;		
	}

	function compareValues(a, b, key) {
		if(a[key] < b[key]) return -1;
		if(a[key] > b[key]) return 1;
		return 0;		
	}

	function updateAttendanceTotals() {
		let grandTotal = 0;
		$('.column-attendance-total').each(function(){
			let parentDiv = $(this).closest('.part');
			let total = parentDiv.find('.co-tile').length;
			let membersLabel = total == 1 ? 'Member' : 'Members';

			grandTotal += total;
			$(this).html(total);
			parentDiv.find('.members-label').html(membersLabel);
		});

		let grandTotalLabel = grandTotal == 1 ? 'Member' : 'Members';
		$('.column-attendance-grand-total').html(grandTotal);
		$('.grand-total-members-label').html(grandTotalLabel);
	}

	// function updateAttendanceReportHeight() {
	// 	if($('#co-attendance-report').length > 0) {
	// 		let windowHeight = $(window).height();
	// 		let report = $('#co-attendance-report');
	// 		let parentDiv = report.parent();

	// 		let reportHeight = windowHeight - report.offset().top - parseInt(parentDiv.css('margin-bottom'));
	// 		report.height(reportHeight - 25);
	// 	}
	// 	if($('#co-availability-report').length > 0) {
	// 		let windowHeight = $(window).height();
	// 		let report = $('#co-availability-report');
	// 		let parentDiv = report.parent();
	// 		let adminBar = $('#wpadminbar');

	// 		let reportHeight = windowHeight - report.offset().top - parseInt(parentDiv.css('margin-bottom'));
	// 		report.height(reportHeight - 25);
	// 	}
	// }

	$(document).on('co_add_attendance_record', '.field.typeahead', function(event, vars){
		const parentDiv = $(this);
		const fieldName = parentDiv.find('.settings').attr('fieldName');
		const settings = JSON.parse(atob(parentDiv.find('.settings').attr('settings')));
		const postId = vars.result.attr('post_id');

		$('.co-tile.attendance[member_id="' + postId + '"]').find('.actions .check').trigger('click');
	});

	$('#co-attendance-report .skew.corner #attendance-alt-colors').on('change', function(){
		const parentDiv = $(this).closest('table');
		if(this.checked) {
			parentDiv.addClass('attendance-alt-colors');
		} else {
			parentDiv.removeClass('attendance-alt-colors');
		}
	});
	
	$('#co-attendance-report .skew.corner #show-fractions').on('change', function(){
		const parentDiv = $(this).closest('table');
		if(this.checked) {
			parentDiv.addClass('showing-fractions');
		} else {
			parentDiv.removeClass('showing-fractions');
		}
	});

	$('#co-attendance-report .skew.corner #show-availability-details').on('change', function(){
		const parentDiv = $(this).closest('table');
		if(this.checked) {
			parentDiv.addClass('showing-availability-details');
		} else {
			parentDiv.removeClass('showing-availability-details');
		}
	});
});